import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SiteCheckoutSuccess from 'components/payments/SiteCheckoutSuccess';
import Immutable from 'immutable';

function mapStateToProps(state, ownProps) {
  const { paymentReducer } = state;
  return {
    siteCheckout: paymentReducer.get('siteCheckout') || Immutable.fromJS({}),
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch),
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SiteCheckoutSuccess);


// WEBPACK FOOTER //
// ./src/containers/SiteCheckoutSuccessContainer.js